module.exports = __webpack_public_path__ + "static/media/banner_02.8e16c41f.png";